import { useUserStore } from 'src/CrudManager/Core/stores/useUserStore'
import type { RouteRecordRaw } from 'vue-router'

export const financesRoutes: RouteRecordRaw[] = [
  {
    path: '/dashboard/finances',
    name: 'finances',
    component: () => import('./FinancesPage.vue'),
    meta: {
      title: 'Finances',
      requiresAuth: true,
    },
    // the same grant the endpoint enforces, checked before the page mounts —
    // the server still 403s, this only spares the dead-end screen
    beforeEnter: () => {
      const userStore = useUserStore()
      if (!userStore.hasPermission('see.reports.financial')) {
        return { path: '/' }
      }
      return true
    },
  },
]

export default financesRoutes
